import { WorkspaceDocumentType } from '../../../entities/WorkspaceDocuments';
import type { WorkspaceDocument } from '../../../entities/WorkspaceDocuments';
import { magellanClient } from '../../../infra/axios';
import type { FileWithPathAndType } from '../bidResponses/dto';

export async function getWorkspaceDocuments() {
  const response = await magellanClient.get<WorkspaceDocument[]>(
    '/workspaceDocuments',
  );

  return response.data;
}

export async function getArchivedWorkspaceDocuments() {
  const response = await magellanClient.get<WorkspaceDocument[]>(
    '/workspaceDocuments/archived',
  );

  return response.data;
}

export async function updateWorkspaceDocument(
  workspaceDocument: WorkspaceDocument,
) {
  const { id: workspaceDocumentId, ...payload } = workspaceDocument;
  const response = await magellanClient.put(
    `/workspaceDocuments/${workspaceDocumentId}`,
    payload,
  );

  return response.data;
}

export async function createWorkspaceDocument(
  files: FileWithPathAndType<WorkspaceDocumentType>[],
) {
  const formData = new FormData();
  for (const { file, type } of files) {
    formData.append(
      type || WorkspaceDocumentType.UNKNOWN,
      file,
      encodeURIComponent(file.name),
    );
  }
  const response = await magellanClient.post('/workspaceDocuments', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
}

export async function archiveWorkspaceDocument(documentId: number) {
  const response = await magellanClient.put(
    `/workspaceDocuments/${documentId}/archive`,
  );

  return response.data;
}

export async function recoverWorkspaceDocument(documentId: number) {
  const response = await magellanClient.put(
    `/workspaceDocuments/${documentId}/recover`,
  );

  return response.data;
}
